import { axiosCall } from "@/utils/axiosCall";
import { selfAssessmentEntity } from "@/components/modules/administration/store/self-assessment-entity";

export const businessCreationActions = {
  async getAccountRolesForTags({ state, commit }) {
    let tagsRoles = [];
    if (state.tags.selected && state.tags.selected.length) {
      for (let index = 0; index < state.tags.selected.length; index++) {
        let tagId = state.tags.selected[index].id;
        await axiosCall({
          url: `Tags/getAccountRoles/${tagId}`,
          method: "Get",
        }).then((data) => {
          let accountRoles = data.data;
          if (accountRoles && accountRoles.length) {
            tagsRoles = [...tagsRoles, ...accountRoles];
          }
        });
      }
      tagsRoles = tagsRoles
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t._id === value._id)
        )
        .map((tagRole) => ({ ...tagRole, id: tagRole._id }));
    }
    commit("SET_ACCOUNTROLES_FOR_TAG", tagsRoles);
  },
  async setDefaultTags({ state, commit, dispatch }) {
    if (!state.tagsToCreate.length) {
      commit("ADD_TAG_TO_CREATE", {
        tag: {
          name: state.business.selfAssessment_general_business_companyName,
          category: "single",
        },
        index: -1,
      });

      await axiosCall({
        url: "Tags",
        method: "Get",
      }).then((data) => {
        let defaultTags = data.data.filter((tag) =>
          ["SYSTEM All Organizations", "PNUD All Organizations"].includes(
            tag.name
          )
        );
        commit("SET_DEFAULT_TAGS", defaultTags);
      });

      /*single company tag*/
      const payload = {};
      payload["storeName"] = "roles";
      await dispatch("addToArray", payload);

      payload["data"] = {};
      payload["storeIndex"] = 0;
      payload["data"]["accountRoleTemplateId"] = "5ca6365e01907047670e1e43";
      payload["data"]["name"] =
        state.business.selfAssessment_general_business_companyName + " role";
      await dispatch("setStoreInfo", payload);

      const payloadTemplates = {};
      payloadTemplates["storeName"] = "roleTemplates";
      await dispatch("addToArray", payloadTemplates);

      payloadTemplates["data"] = {};
      payloadTemplates["storeIndex"] = 0;
      payloadTemplates["data"]["ruledBy"] = "ruleByTagId";
      payloadTemplates["data"]["ruledByValue"] = {
        category: "single",
        name: state.business.selfAssessment_general_business_companyName,
        new: true,
      };
      await dispatch("setStoreInfo", payloadTemplates);

      const payloadUsers = {};
      payloadUsers["storeName"] = "users";
      await dispatch("addToArray", payloadUsers);

      payloadUsers["data"] = {};
      payloadUsers["storeIndex"] = 0;
      payloadUsers["data"]["email"] =
        state.business.selfAssessment_general_business_email;
      payloadUsers["data"]["username"] =
        state.business.selfAssessment_general_business_email;
      await dispatch("setStoreInfo", payloadUsers);

      const payloadRoles = {};
      payloadRoles["data"] = {};
      payloadRoles["storeName"] = 'accountRoles';
      payloadRoles["storeIndex"] = 0;
      payloadRoles["data"]["selected"] = [
        `5ca6365e01907047670e1e43|||${state.business.selfAssessment_general_business_companyName + " role"}`
      ];
      await dispatch("setStoreInfo", payloadRoles);
    }
  },
  async rebuildRolesFromGroupTag({ state, commit, dispatch }) {
    await dispatch("removeGroupRoles");
    if (state.tagsToCreate.length > 1) {
      await dispatch("createRolesFromGroupTags");
    }
  },
  async removeGroupRoles({ state, commit, dispatch }) {
    /*remove previously created roles*/
    if (state.roles.length > 1) {
      for (let i = 0; i < state.roles.length; i++) {
        const payload = {};
        payload["storeName"] = "roles";
        payload["index"] = 1;
        await dispatch("removeFromArray", payload);
      }
    }
    if (state.roleTemplates.length > 1) {
      for (let i = 0; i < state.roleTemplates.length; i++) {
        const payload = {};
        payload["storeName"] = "roleTemplates";
        payload["index"] = 1;
        await dispatch("removeFromArray", payload);
      }
    }
  },
  async createRolesFromGroupTags({ state, dispatch }) {
    /*group company tag*/
    const payload = {};
    payload["storeName"] = "roles";
    await dispatch("addToArray", payload);

    payload["data"] = {};
    payload["storeIndex"] = 1;
    payload["data"]["accountRoleTemplateId"] = "5ca6365e01907047670e1e43";
    payload["data"]["name"] = state.tagsToCreate[1].name + " role";
    await dispatch("setStoreInfo", payload);

    const payloadTemplates = {};
    payloadTemplates["storeName"] = "roleTemplates";
    dispatch("addToArray", payloadTemplates);

    payloadTemplates["data"] = {};
    payloadTemplates["storeIndex"] = 1;
    payloadTemplates["data"]["ruledBy"] = "ruleByTagId";
    payloadTemplates["data"]["ruledByValue"] = {
      ...state.tagsToCreate[1],
      new: true,
    };
    dispatch("setStoreInfo", payloadTemplates);
  },
  createBusiness: async ({ state, dispatch }) => {
    let businessId = "";
    const payload = {};
    payload["data"] = {};
    payload["storeName"] = "createdIds";
    payload["storeIndex"] = -1;
    payload["data"]["business"] = "creating";
    await dispatch("setCreatedIds", payload);

    await axiosCall({
      url: "Businesses",
      method: "post",
      data: state.business,
    })
      .then(async (response) => {
        businessId = response.data.id;
      })
      .catch(async () => {
        businessId = "error";
        await dispatch("rollback");
      });

    payload["data"]["business"] = businessId;
    await dispatch("setCreatedIds", payload);
    if (businessId !== "error") {
      await dispatch("createTag");
    }
  },
  createTag: async ({ state, dispatch }) => {
    let tagsIds = [];
    let hasFailed = false;
    state.tagsToCreate.map(async (tagToCreate, index) => {
      if (!hasFailed) {
        let currentTagId = "";
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = index;
        payload["data"]["tags"] = "creating";
        await dispatch("setCreatedIds", payload);

        await axiosCall({
          url: "Tags",
          method: "post",
          data: {
            name: tagToCreate.name,
            category: tagToCreate.category,
            public: false,
          },
        })
          .then((response) => {
            tagsIds.push({ id: response.data.id, name: tagToCreate.name });
            currentTagId = response.data.id;
          })
          .catch(async () => {
            currentTagId = "error";
            hasFailed = true;
            await dispatch("rollback");
          });

        payload["data"]["tags"] = currentTagId;
        await dispatch("setCreatedIds", payload);
      }
    });

    if (!hasFailed) {
      tagsIds.map(async (tagId) => {
        if (!hasFailed) {
          await dispatch("setTagIdToRuledBy", {
            id: tagId.id,
            name: tagId.name,
          });
        }
      });
    }

    if (!hasFailed) {
      setTimeout(() => {
        dispatch("assignTags");
      }, 1000);
    }
  },
  assignTags: async ({ state, dispatch }) => {
    let hasFailed = false;

    // add just created tags
    if (state.createdIds.tags && state.createdIds.tags.length) {
      for (let index = 0; index < state.createdIds.tags.length; index++) {
        if (!hasFailed) {
          const tagId = state.createdIds.tags[index];

          let assign = await assignTaskRequest(
            { state, dispatch },
            {
              tagId,
              index,
              storeName: "newTagsAssigned",
            }
          );
          hasFailed = hasFailed && assign;
        }
      }
    }

    // add default tags
    if (state.defaultTags && state.defaultTags.length) {
      for (let index = 0; index < state.defaultTags.length; index++) {
        if (!hasFailed) {
          const tagId = state.defaultTags[index].id;
          let assign = await assignTaskRequest(
            { state, dispatch },
            {
              tagId,
              index,
              storeName: "defaultTagsAssigned",
            }
          );
          hasFailed = hasFailed && assign;
        }
      }
    }

    // add selected tags
    if (state.tags && state.tags.selected && state.tags.selected.length) {
      for (let index = 0; index < state.tags.selected.length; index++) {
        if (!hasFailed) {
          const tagId = state.tags.selected[index].id;
          let assign = await assignTaskRequest(
            { state, dispatch },
            {
              tagId,
              index: index,
              storeName: "selectedTagsAssigned",
            }
          );
          hasFailed = hasFailed && assign;
        }
      }
    }

    if (!hasFailed) {
      await dispatch("createSnapshot");
    }
  },

  createSnapshot: async ({ state, dispatch }) => {
    let snapshotId = "";
    const payload = {};
    payload["data"] = {};
    payload["storeName"] = "createdIds";
    payload["storeIndex"] = -1;
    payload["data"]["snapshot"] = "creating";
    await dispatch("setCreatedIds", payload);

    await axiosCall({
      url: "Snapshots",
      method: "post",
      data: {
        businessId: state.createdIds.business,
        status: "label_configuration_snapshot_active",
        startDate: new Date(),
      },
    })
      .then((response) => {
        snapshotId = response.data.id;
      })
      .catch(async () => {
        snapshotId = "error";
        await dispatch("rollback");
      });

    payload["data"]["snapshot"] = snapshotId;
    await dispatch("setCreatedIds", payload);

    if (snapshotId !== "error") {
      await dispatch("createAssessment");
    }
  },
  createAssessment: async ({ state, dispatch }) => {
    const payload = {};
    payload["data"] = {};
    payload["storeName"] = "createdIds";
    payload["storeIndex"] = -1;
    payload["data"]["assessment"] = "creating";
    await dispatch("setCreatedIds", payload);

    const data = selfAssessmentEntity;
    data.snapshotId = state.createdIds.snapshot;
    let selfAssessmentId = "";
    await axiosCall({
      url: "SelfAssessments",
      method: "post",
      data,
    })
      .then((response) => {
        selfAssessmentId = response.data.id;
      })
      .catch(async () => {
        selfAssessmentId = "error";
        await dispatch("rollback");
      });

    payload["data"]["assessment"] = selfAssessmentId;
    await dispatch("setCreatedIds", payload);

    if (selfAssessmentId !== "error") {
      await dispatch("createRoles");
    }
  },
  createRoles: async ({ state, dispatch }) => {
    let hasFailed = false;
    for (let index = 0; index < state.roles.length; index++) {
      if (!hasFailed) {
        const data = { ...state.roles[index] };
        delete data.selected;
        let roleId = "";
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = index;
        payload["data"]["roles"] = "creating";
        await dispatch("setCreatedIds", payload);

        await axiosCall({
          url: "AccountRoles",
          method: "post",
          data,
        })
          .then((response) => {
            roleId = response.data.id;
          })
          .catch(async () => {
            roleId = "error";
            await dispatch("rollback");
            hasFailed = true;
          });

        payload["data"]["roles"] = roleId;
        await dispatch("setCreatedIds", payload);
      }
    }
    if (!hasFailed) {
      await dispatch("createAccessControls");
    }
  },
  createAccessControls: async ({ state, dispatch }) => {
    let hasFailed = false;
    for (let index = 0; index < state.roleTemplates.length; index++) {
      let accessControlId = "";
      const payload = {};
      payload["data"] = {};
      payload["storeName"] = "createdIds";
      payload["storeIndex"] = index;
      payload["data"]["roleTemplates"] = "creating";
      await dispatch("setCreatedIds", payload);
      let ruleById = state.createdIds.tags[index];
      var data = {
        ...state.roleTemplates[index],
        ruledByValue: ruleById,
      };
      data.accountRoleId = state.createdIds.roles[index];
      await axiosCall({
        url: `AccessControls/createAccessControls`,
        method: "post",
        data,
      })
        .then((response) => {
          accessControlId = `${response.data.length}`;
        })
        .catch(async () => {
          accessControlId = "error";
          hasFailed = true;
          await dispatch("rollback");
        });
      payload["data"]["roleTemplates"] = accessControlId;
      await dispatch("setCreatedIds", payload);
    }
    if (!hasFailed) {
      await dispatch("createUsers");
    }
  },
  createUsers: async ({ state, dispatch }) => {
    let hasFailed = false;
    for (let index = 0; index < state.users.length; index++) {
      if (!hasFailed) {
        let userid = "";
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "createdIds";
        payload["storeIndex"] = index;
        payload["data"]["users"] = "creating";
        await dispatch("setCreatedIds", payload);
        const data = { ...state.users[index] };
        delete data.selected;
        await axiosCall({
          url: "UserAccounts/signup",
          method: "post",
          data,
        })
          .then(async (response) => {
            userid = response.data.id;
          })
          .catch(async () => {
            hasFailed = true;
            userid = "error";
            await dispatch("rollback");
          });
        payload["data"]["users"] = userid;
        await dispatch("setCreatedIds", payload);
      }
    }
    if (!hasFailed) {
      await dispatch("assignRolesToUsers");
    }
  },
  assignRolesToUsers: async ({ state, dispatch }) => {
    let hasFailed = false;
    for (
      let userIndex = 0;
      userIndex < state.createdIds.users.length;
      userIndex++
    ) {
      let accountRoles = state.accountRoles[userIndex];
      let userAccountId = state.createdIds.users[userIndex];
      if (!hasFailed) {
        for (let index = 0; index < accountRoles.selected.length; index++) {
          if (!hasFailed) {
            let userAccountRole = "";
            const payload = {};
            payload["data"] = {};
            payload["storeName"] = "createdIds";
            payload["storeIndex"] = userIndex;
            payload["storeSecondIndex"] = index;
            payload["data"]["userAccountRoles"] = "creating";
            await dispatch("setCreatedIds", payload);

            const accountRole = { ...accountRoles.selected[index] };
            let id = accountRole.id;
            if (!id) {
              state.roles.map((role, rIndex) => {
                if (role.name === accountRole.name) {
                  id = state.createdIds.roles[rIndex];
                }
              });
            }
            const data = { userAccountId, accountRoleId: id };
            await axiosCall({
              url: "UserAccountRoles",
              method: "post",
              data,
            })
              .then((response) => {
                userAccountRole = response.data.id;
              })
              .catch(async () => {
                hasFailed = true;
                userAccountRole = "error";
                await dispatch("rollback");
              });
            payload["data"]["userAccountRoles"] = userAccountRole;
            await dispatch("setCreatedIds", payload);
          }
        }
      }
    }
    if (!hasFailed) {
      setTimeout(() => {
        dispatch("setBusinessCreated", "ok");
        dispatch("setIsSubmitting", false);
      }, 1000);
    }
  },
};

let assignTaskRequest = async (
  { state, dispatch },
  { tagId, index, storeName }
) => {
  let businessTagId = "";
  await axiosCall({
    url: "BusinessTags",
    method: "post",
    data: { businessId: state.createdIds.business, tagId },
  })
    .then((response) => {
      businessTagId = response.data.id;
    })
    .catch(async () => {
      businessTagId = "error";
      await dispatch("rollback");
    });

  const payload = {};
  payload["data"] = {};
  payload["storeName"] = "createdIds";
  payload["storeIndex"] = index;
  payload["data"][storeName] = businessTagId;
  await dispatch("setCreatedIds", payload);

  return businessTagId !== "error";
};
